export default __webpack_public_path__ + "static/media/Artesanias-San-juan-de-Oriente.c28b750b.jpg";